import { useState, useRef, useEffect } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useConfig } from '../contexts/ConfigContext'
import api from '../services/api'
import PerfilModal from './PerfilModal'
import { useNavegacaoLista } from '../hooks/useNavegacaoLista'

const PRIMARY = 'var(--primary)'
const fmtData = (d) => d ? d.split('T')[0].split('-').reverse().join('/') : '—'

export default function Navbar() {
  const { usuario, logout, temAcesso, ehGestor } = useAuth()
  const { config } = useConfig()
  const navigate = useNavigate()
  const location = useLocation()
  const handleLogout = () => { logout(); navigate('/login') }

  const [qBusca, setQBusca] = useState('')
  const [resultadosBusca, setResultadosBusca] = useState({ clientes: [], itens: [] })
  const [buscaAberta, setBuscaAberta] = useState(false)
  const buscaRef = useRef(null)
  const buscaTimeout = useRef(null)

  useEffect(() => {
    const handler = (e) => { if (buscaRef.current && !buscaRef.current.contains(e.target)) setBuscaAberta(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const onChangeBusca = (v) => {
    setQBusca(v)
    navBusca.reset()
    clearTimeout(buscaTimeout.current)
    const termo = v.trim()
    if (termo.length < 2) {
      setResultadosBusca({ clientes: [], itens: [] })
      setBuscaAberta(false)
      return
    }
    buscaTimeout.current = setTimeout(() => {
      api.get(`/busca?q=${encodeURIComponent(termo)}`)
        .then(r => { setResultadosBusca(r.data); setBuscaAberta(true) })
        .catch(() => setResultadosBusca({ clientes: [], itens: [] }))
    }, 300)
  }

  // Se ja estiver na tela de Apolices, o navigate('/apolices') nao remonta a pagina (mesma rota),
  // entao o filtro guardado no sessionStorage so seria lido na proxima vez que a tela abrisse.
  // Forca reload nesse caso especifico pra o filtro ser aplicado na hora.
  const irParaApolicesComFiltro = (chave, valor) => {
    sessionStorage.setItem(chave, valor)
    sessionStorage.removeItem(chave === 'filtroClienteId' ? 'filtroApoliceId' : 'filtroClienteId')
    setQBusca('')
    setResultadosBusca({ clientes: [], itens: [] })
    setBuscaAberta(false)
    if (location.pathname === '/apolices') window.location.href = '/apolices'
    else navigate('/apolices')
  }

  const temResultados = resultadosBusca.clientes.length > 0 || resultadosBusca.itens.length > 0
  const selecionarResultado = (i) => {
    if (i < resultadosBusca.clientes.length) irParaApolicesComFiltro('filtroClienteId', resultadosBusca.clientes[i].id)
    else irParaApolicesComFiltro('filtroApoliceId', resultadosBusca.itens[i - resultadosBusca.clientes.length].apolice_id)
  }
  const navBusca = useNavegacaoLista(resultadosBusca.clientes.length + resultadosBusca.itens.length, selecionarResultado)

  return (
    <>
      {/* Logo Box flutuante */}
      <div style={{
        position: 'fixed', top: 0, left: 28, zIndex: 60,
        background: '#fff',
        boxShadow: '0 6px 20px rgba(0,0,0,0.10)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: '0 0 16px 16px',
        border: `1px solid rgba(var(--primary-rgb),0.15)`,
        borderTop: 'none',
        width: 187, height: 126,
        padding: '10px 12px',
      }}>
        <img
          src={config.logo || '/logo_emseg.png'}
          alt={config.nome}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>

      {/* Navbar */}
      <nav style={{
        position: 'fixed', top: 0, width: '100%', zIndex: 50,
        borderBottom: `2px solid rgba(var(--primary-rgb),0.15)`,
        background: '#fefcfa',
        fontFamily: 'Manrope, system-ui, sans-serif',
      }}>
        {/* Linha 1: Busca */}
        <div style={{
          width: '100%',
          background: '#fbf9f7',
          borderBottom: '1px solid rgba(var(--primary-rgb),0.08)',
          padding: '10px 28px',
        }}>
          <div ref={buscaRef} style={{ maxWidth: 560, margin: '0 auto', position: 'relative' }}>
            <span className="material-symbols-outlined" style={{
              position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
              fontSize: 18, color: '#999', lineHeight: 1,
            }}>search</span>
            <input
              type="text"
              placeholder="Pesquisar por nome, CPF/CNPJ, telefone, e-mail, placa ou chassi..."
              value={qBusca}
              onChange={e => onChangeBusca(e.target.value)}
              onKeyDown={navBusca.onKeyDown}
              style={{
                width: '100%',
                paddingLeft: 42, paddingRight: 16, paddingTop: 9, paddingBottom: 9,
                background: '#EDECEA',
                border: 'none', borderRadius: 12,
                fontSize: 13, fontFamily: 'Manrope, sans-serif',
                color: '#333',
                outline: 'none',
              }}
              onFocus={e => { e.target.style.boxShadow = `0 0 0 2px rgba(var(--primary-rgb),0.35)`; if (temResultados) setBuscaAberta(true) }}
              onBlur={e => { e.target.style.boxShadow = 'none' }}
            />
            {buscaAberta && temResultados && (
              <div style={{
                position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, zIndex: 200,
                background: '#fff', borderRadius: 12,
                boxShadow: '0 8px 24px rgba(0,0,0,0.14)',
                border: '1px solid rgba(0,0,0,0.08)',
                maxHeight: 360, overflowY: 'auto',
              }}>
                {resultadosBusca.clientes.map((c, i) => (
                  <button key={`cliente-${c.id}`} type="button"
                    onClick={() => irParaApolicesComFiltro('filtroClienteId', c.id)}
                    onMouseEnter={() => navBusca.setIndice(i)}
                    style={{ display: 'flex', flexDirection: 'column', width: '100%', textAlign: 'left', padding: '10px 16px', background: i === navBusca.indice ? 'rgba(var(--primary-rgb),0.08)' : 'none', border: 'none', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
                  >
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#333', fontFamily: 'Manrope, sans-serif' }}>{c.nome}</span>
                    <span style={{ fontSize: 11, color: '#888' }}>{c.cpf_cnpj || 'Cliente'}</span>
                  </button>
                ))}
                {resultadosBusca.itens.map((it, i) => (
                  <button key={`item-${it.apolice_id}-${i}`} type="button"
                    onClick={() => irParaApolicesComFiltro('filtroApoliceId', it.apolice_id)}
                    onMouseEnter={() => navBusca.setIndice(resultadosBusca.clientes.length + i)}
                    style={{ display: 'flex', flexDirection: 'column', width: '100%', textAlign: 'left', padding: '10px 16px', background: resultadosBusca.clientes.length + i === navBusca.indice ? 'rgba(var(--primary-rgb),0.08)' : 'none', border: 'none', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
                  >
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#333', fontFamily: 'Manrope, sans-serif' }}>
                      {it.item_placa || '—'} {it.item_chassi ? `· ${it.item_chassi}` : ''} {it.item_modelo ? `— ${it.item_modelo}` : ''}
                    </span>
                    <span style={{ fontSize: 11, color: '#888' }}>
                      {it.cliente_nome} · {it.numero_apolice || it.emissao_numero_apolice || it.tipo_documento}
                      {it.data_inicio && ` · Vig. ${fmtData(it.data_inicio)} a ${fmtData(it.data_vencimento)}`}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Linha 2: Links de navegação */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '10px 28px',
        }}>
          {/* Links — deslocados para a direita do logo box */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 2, paddingLeft: 199 }}>
            {temAcesso('home') && <NavItem to="/home" label="Home" />}
            {temAcesso('crm') && <NavItem to="/crm" label="CRM" />}
            <NavDropdown label="Documentos" items={[
              temAcesso('propostas') && { to: '/propostas', label: 'Propostas' },
              temAcesso('apolices') && { to: '/apolices', label: 'Apólices' },
              temAcesso('renovacoes') && { to: '/renovacoes', label: 'Renovações' },
              temAcesso('crm') && { to: '/perdidos', label: 'Perdidos' },
              temAcesso('sinistros') && { to: '/sinistros', label: 'Sinistros' },
              temAcesso('assistencias') && { to: '/assistencias', label: 'Assistência' },
            ].filter(Boolean)} />
            <NavDropdown label="Financeiro" items={[
              temAcesso('fluxo_caixa') && { to: '/fluxo-caixa', label: 'Fluxo de Caixa' },
              temAcesso('comissoes') && { to: '/comissoes',   label: 'Comissões' },
              temAcesso('parcelas_atraso') && { to: '/parcelas-atraso', label: 'Parcelas em Atraso' },
              ehGestor && { to: '/recibo-socios', label: 'Recibo de Sócios' },
            ].filter(Boolean)} />
            <NavDropdown label="Relatórios" items={[
              temAcesso('indicacoes') && { to: '/relatorios/indicacoes', label: 'Indicações' },
            ].filter(Boolean)} />
            <NavDropdown label="Cadastros" items={[
              temAcesso('clientes') && { to: '/clientes', label: 'Clientes' },
              temAcesso('cad_seguradoras') && { to: '/cadastro?tab=seguradoras', label: 'Seguradoras' },
              temAcesso('cad_ramos') && { to: '/cadastro?tab=ramos',       label: 'Ramos' },
              temAcesso('cad_coberturas') && { to: '/cadastro?tab=coberturas',  label: 'Coberturas' },
              temAcesso('cad_comissao') && { to: '/cadastro?tab=comissao',    label: 'Comissão' },
              temAcesso('cad_financeiro') && { to: '/cadastro?tab=financeiro',  label: 'Financeiro' },
              temAcesso('cad_emails') && { to: '/cadastro?tab=emails',      label: 'Modelos de E-mail' },
              ehGestor && { to: '/cadastro?tab=usuarios', label: 'Usuários' },
              ehGestor && { to: '/cadastro?tab=corretora', label: 'Corretora' },
              ehGestor && { to: '/cadastro?tab=log', label: 'Log de Auditoria' },
            ].filter(Boolean)} />
            {ehGestor && <NavItem to="/dashboard" label="Dashboard" />}
          </div>

          {/* Direita: notificações + usuário */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button style={{
              background: 'none', border: 'none', padding: 7, borderRadius: 8,
              cursor: 'pointer', color: '#777', display: 'flex', alignItems: 'center',
              transition: 'background 0.15s',
            }}
              onMouseEnter={e => e.currentTarget.style.background = '#f0f0f0'}
              onMouseLeave={e => e.currentTarget.style.background = 'none'}
            >
              <span className="material-symbols-outlined" style={{ fontSize: 20 }}>notifications</span>
            </button>

            <MenuUsuario onLogout={handleLogout} />
          </div>
        </div>
      </nav>
    </>
  )
}

function NavDropdown({ label, items }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  const location = useLocation()
  const isActive = items.some(item => location.pathname === item.to.split('?')[0])

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  if (items.length === 0) return null

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: 4,
          padding: '7px 14px',
          borderRadius: 999, border: 'none', cursor: 'pointer',
          fontSize: 15, fontWeight: 600,
          fontFamily: 'Manrope, sans-serif',
          background: isActive ? 'var(--primary-light)' : 'transparent',
          color: isActive ? 'var(--primary-dark)' : '#666',
          transition: 'all 0.15s',
        }}
        onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = 'var(--primary-light)'; e.currentTarget.style.color = PRIMARY } }}
        onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#666' } }}
      >
        {label}
        <span style={{ fontSize: 10, marginTop: 1 }}>▾</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 200,
          background: '#fff', borderRadius: 10,
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          border: '1px solid rgba(0,0,0,0.08)',
          minWidth: 160, overflow: 'hidden',
        }}>
          {items.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              style={({ isActive: a }) => ({
                display: 'block', padding: '10px 16px',
                fontSize: 13, fontWeight: 500,
                fontFamily: 'Manrope, sans-serif',
                textDecoration: 'none',
                color: a ? PRIMARY : '#333',
                background: a ? 'rgba(var(--primary-rgb),0.06)' : 'transparent',
                transition: 'background 0.12s',
              })}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(var(--primary-rgb),0.06)'; e.currentTarget.style.color = PRIMARY }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#333' }}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  )
}

function NavItem({ to, label }) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        display: 'flex', alignItems: 'center',
        padding: '7px 14px',
        borderRadius: 999,
        fontSize: 15, fontWeight: 600,
        textDecoration: 'none',
        transition: 'all 0.15s',
        fontFamily: 'Manrope, sans-serif',
        color: isActive ? 'var(--primary-dark)' : '#666',
        background: isActive ? 'var(--primary-light)' : 'transparent',
      })}
      onMouseEnter={e => { if (e.currentTarget.getAttribute('aria-current') !== 'page') { e.currentTarget.style.background = 'var(--primary-light)'; e.currentTarget.style.color = PRIMARY } }}
      onMouseLeave={e => { if (e.currentTarget.getAttribute('aria-current') !== 'page') { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#666' } }}
    >
      {label}
    </NavLink>
  )
}

function MenuUsuario({ onLogout }) {
  const { usuario } = useAuth()
  const [open, setOpen] = useState(false)
  const [perfilAberto, setPerfilAberto] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', borderRadius: 8 }}
      >
        <div style={{
          width: 32, height: 32, borderRadius: '50%',
          background: usuario?.foto ? `url(${usuario.foto}) center/cover` : 'rgba(var(--primary-rgb),0.12)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 13, fontWeight: 700, color: PRIMARY, border: `2px solid rgba(var(--primary-rgb),0.2)`,
          flexShrink: 0,
        }}>
          {!usuario?.foto && (usuario?.nome || 'U')[0].toUpperCase()}
        </div>
        <span style={{ fontSize: 12, color: '#888', fontFamily: 'Manrope, sans-serif' }}>
          {usuario?.nome}
        </span>
        <span style={{ fontSize: 10, color: '#999', marginTop: 1 }}>▾</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', right: 0, zIndex: 200,
          background: '#fff', borderRadius: 10,
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          border: '1px solid rgba(0,0,0,0.08)',
          minWidth: 160, overflow: 'hidden',
        }}>
          <button
            onClick={() => { setOpen(false); setPerfilAberto(true) }}
            style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 16px', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'Manrope, sans-serif', color: '#333' }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(var(--primary-rgb),0.06)'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}
          >
            Perfil
          </button>
          <button
            onClick={onLogout}
            style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 16px', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'Manrope, sans-serif', color: '#333' }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(var(--primary-rgb),0.06)'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}
          >
            Sair
          </button>
        </div>
      )}
      {perfilAberto && <PerfilModal onClose={() => setPerfilAberto(false)} />}
    </div>
  )
}
